import React from 'react';
import {
  ISchemaDataModelFieldsFragment,
  ITableColumnFieldsFragment,
} from '../../../../utils/apollo/graphqlSchema';
import { useEditJoinModel } from './utils';
import { JoinConditionHeader, JoinConditionRow } from './DataModelerJoinUI';
import DataModelerEditJoin from './DataModelerEditJoin';
import { SvgIcon } from '../../../../components/Icon';
import KubitTooltip from '../../../../components/KubitTooltip';
import { isInvalidJoinData } from '../validation';
import { UnderTableHeaderDiv } from '../DataModelerCommonUI';
import { assertNotNil } from '../../../../utils/types';
import InformationalTooltip from '../../../../components/InformationalTooltip';
import { dataModelLabelInfoTooltipOptions } from '../../../../components/KubitTooltip/globalTooltips';

interface IProps {
  schemaObj: ISchemaDataModelFieldsFragment;
  isEditMode: boolean;
  viewKey: string;
  tableKey: string;
  availableColumnsFromServer: ITableColumnFieldsFragment[];
}

const DataModelerJoin = ({
  schemaObj,
  isEditMode,
  viewKey,
  tableKey,
  availableColumnsFromServer,
}: IProps) => {
  const { editModel, customJoinMeta } = useEditJoinModel({
    viewKey,
    isEditMode,
  });

  if (customJoinMeta) {
    // custom join - no edits available
    return <JoinConditionRow>{customJoinMeta.description}</JoinConditionRow>;
  }
  assertNotNil(editModel);
  return (
    <>
      <JoinConditionHeader>
        <UnderTableHeaderDiv>
          <span>Join Condition</span>
          <InformationalTooltip
            tooltipOption={dataModelLabelInfoTooltipOptions.joinConditionTitle}
          />
        </UnderTableHeaderDiv>
        {isInvalidJoinData(editModel.joinData) && (
          <KubitTooltip
            noOpenDelay={true}
            content={
              editModel.joinData.conditions.length === 0
                ? 'At least one condition required'
                : 'Incomplete Temporal condition definition'
            }
          >
            <SvgIcon width={8} height={12} name={'error-icon'} />
          </KubitTooltip>
        )}
      </JoinConditionHeader>
      <DataModelerEditJoin
        isEditMode={isEditMode}
        joinModel={editModel}
        schemaObj={schemaObj}
        viewKey={viewKey}
        tableKey={tableKey}
        availableColumnsFromServer={availableColumnsFromServer}
      />
    </>
  );
};

export default DataModelerJoin;
